import React from 'react';

import PropTypes from 'prop-types';

import Downshift from 'downshift';
import FormFeedback from 'reactstrap/lib/FormFeedback';
import FormText from 'reactstrap/lib/FormText';
import Loader from 'atoms/Loader';

import styles from './styles.module.scss';

class AsyncMultiSelectDropdownAtom extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleToggleMenu = this.handleToggleMenu.bind(this);
    this.a = null;
    this.state = {
      isOpen: false,
      selectedItems: props.input.value || [],
      items: props.items || [],
      inputValue: "",
      isLoading: false,
    };
  }


  componentWillReceiveProps(nextProps) {
    this.setState({items: nextProps.items});
    if(nextProps.input.value !== this.props.input.value){
      this.setState({ selectedItems: nextProps.input.value ? nextProps.input.value : [] });
    }
  }

  handleChange(item) {
    const { selectedItems } = this.state;
    if (selectedItems.filter(i => item.id === i.id).length) {
      this.removeItem(item);
    } else {
      this.addSelectedItem(item);
    }
  }

  handleInputChange(e) {
    this.setState({inputValue: e.target.value})
    e.stopPropagation();
    return true;
  }

  addSelectedItem(item) {
    const { input, getSelectedItems } = this.props;
    this.setState({inputValue: ""});
    this.setState({items: this.props.items});
    this.setState(({selectedItems}) => ({
      selectedItems: [...selectedItems, item],
    }));
    input.onChange([...this.state.selectedItems, item]);
    getSelectedItems &&  getSelectedItems([...this.state.selectedItems, item]);
  }

  /* eslint-disable */
  removeItem(item) {
    const { input, getSelectedItems } = this.props;
    this.setState(({ selectedItems }) => {
      return {
        selectedItems: selectedItems.filter(i => item.id !== i.id),
      };
    });
    input.onChange(this.state.selectedItems.filter(i => item.id !== i.id));
    getSelectedItems &&  getSelectedItems(this.state.selectedItems.filter(i => item.id !== i.id));
  }
  /* eslint-enable */

  // handleStateChange(changes) {
  //   const { isOpen, type } = changes;
  //   if (type === Downshift.stateChangeTypes.mouseUp) {
  //     this.setState({ isOpen });
  //   }
  // }

  handleToggleMenu() {
    this.setState(({ isOpen }) => ({ isOpen: !isOpen }));
  }

  render() {
    const {
      input,
      label,
      id,
      itemToString,
      help,
      placeholder,
      meta: { touched, error },
    } = this.props;
    const { isOpen, items, selectedItems, inputValue, isLoading } = this.state;
    return (
      /* eslint-disable */
      <Downshift
        itemToString={itemToString}
        onSelect={this.handleChange}
        // onStateChange={this.handleStateChange}
        defaultSelectedItem={selectedItems}
        selectedItem={selectedItems}
        isOpen={isOpen}
        onOuterClick={this.handleToggleMenu}
        render={({
          getInputProps,
          getButtonProps,
          getItemProps,
          getLabelProps,
          isOpen,
          selectedItem,
          highlightedIndex,
        }) => {
          return (<div style={{ position: 'relative' }} className="custom-multi-select">
            {label &&
              <label
                {...getLabelProps({
                  htmlFor: id,
                  className: 'col-form-label',
                  style: { width: '100%' },
                })}
              >
                {label}
              </label>
            }
            {/* eslint-enable */}
            <div
              {...getButtonProps({
                className: `${styles['multi-select']} muti-select-wrap`,
                onClick: this.handleToggleMenu,
              })}
            >
              <div className={styles['multi-select__content']}>
                {selectedItem && selectedItem.length > 0 &&
                  selectedItem.map(item =>
                    <label
                      key={item.id}
                      className={styles['multi-select__chip']}
                      htmlFor="chip"
                    >
                      {itemToString(item)}
                      <span
                        className="pointer"
                        role="button"
                        tabIndex="0"
                        onClick={e => {
                          e.stopPropagation();
                          this.removeItem(item);
                        }}
                      >
                        &nbsp;x
                      </span>
                    </label>,
                  )
                }
                <input
                  {...getButtonProps({
                     onKeyUp: (e) => {
                       if((e.target.value).length < 3) return;  
                       if(this.a) return; 
                       this.setState({isLoading : true})            
                        this.a = setTimeout(() => {
                          this.props.getData(inputValue)
                          this.a = null
                          this.setState({isLoading : false})
                      }, 3000)
                    },
                    placeholder: selectedItem.length ? '' : placeholder,
                    onChange: this.handleInputChange,
                    onClick: (e) => {
                      if (isOpen) e.stopPropagation();
                    },
                    value: inputValue,
                    className: styles['multi-select__input']
                  })}
                  data-lpignore={true}
                  autoComplete="off"
                />
              </div>
            </div>
            { isLoading ? 
                <span style={{ position: 'absolute', top: '35px', right: '9px' }} className="d-inline-block loader-pos"><Loader active /></span>
                : <span onClick={this.handleToggleMenu} style={{ position: 'absolute' }} className="dropdown-arrow d-inline-block" />}
            {isOpen ? (
              <div className={styles['multi-select__dropdown']}>
                {items && items.length
                  ? items.map((item, index) => (
                    <div
                      key={item.id}
                      {...getItemProps({item})}
                      style={{
                        backgroundColor:
                          highlightedIndex === index ? '#9CDAD7' : 'white',
                        fontWeight: selectedItems.length && selectedItems.filter(i => item.id === i.id).length > 0
                          ? 'bold' : 'normal',
                      }}
                      className="cursor-pointer advance-filter-drop"
                    >
                      {itemToString(item)}
                    </div>
                  ))
                  : <div className={styles['multi-select__no-results']}>No Results Found</div>
                }
              </div>
            ) : null}
            <FormText color="muted">{help}</FormText>
            <FormFeedback>{touched && error}</FormFeedback>
          </div>);
        }}
      />
    );
  }
}

AsyncMultiSelectDropdownAtom.propTypes = {
  items: PropTypes.array,
  onChange: PropTypes.func,
  itemToString: PropTypes.func,
  getData: PropTypes.func,
};

export default AsyncMultiSelectDropdownAtom;
